import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';

import commonSlice from '../features/common/common.slice';
import authSlice from '../features/auth/auth.slice';
import layoutSlice from '../features/layout/layout.slice';

import { reduxApiService } from '../services/reduxApi.service';
import myTicketsSlice from '../features/myTickets/myTickets.slice';
import attendTicketsSlice from '../features/attendTickets/attendTickets.slice';
import approveTicketsSlice from '../features/approveTickets/approveTickets.slice';
import sharedTicketsSlice from '../features/sharedTickets/sharedTickets.slice';
import checkTicketsSlice from '../features/checkTickets/checkTickets.slice';
import contactsSlice from '../features/contacts/contacts.slice';
import { manufacturingRouteApi } from '../services/manufacturingRouteApi.service';
import myRequestSlice from '../features/manufacturingRoutes/myRequest/myRequest.slice';
import myRequestSumarySlice from '../features/manufacturingRoutes/myRequest/myRequestSumary.slice';
import sheetOlimpicaSlice from '../features/manufacturingRoutes/sheetSkuMallaOlimpica/sheetSkuOlimpica.slice';
import sheetPlastificadoSlice from '../features/manufacturingRoutes/sheetSkuMallaOlimpicaPlastificada/sheetSkuPlastificado.slice';
const combinedReducer = combineReducers({
  [reduxApiService.reducerPath]: reduxApiService.reducer,
  [manufacturingRouteApi.reducerPath]: manufacturingRouteApi.reducer,
  common: commonSlice,
  auth: authSlice,
  layout: layoutSlice,
  myTickets: myTicketsSlice,
  myRequest: myRequestSlice,
  myRequestSumary: myRequestSumarySlice,
  attendTickets: attendTicketsSlice,
  approveTickets: approveTicketsSlice,
  sharedTickets: sharedTicketsSlice,
  checkTickets: checkTicketsSlice,
  contacts: contactsSlice,
  sheetSkuMallaOlimpica: sheetOlimpicaSlice,
  sheetSkuMallaPlastificado: sheetPlastificadoSlice,
});

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === 'auth/setCredentials') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      reduxApiService.middleware,
      manufacturingRouteApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
